import { render, staticRenderFns } from "./NumberIcon.vue?vue&type=template&id=6a65815c&"
import script from "./NumberIcon.vue?vue&type=script&lang=js&"
export * from "./NumberIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports